<template>
  <div class="confirmation-details">
    <p v-if="!scheduleId">Agendamento não vinculado a esta confirmação.</p>
    <p v-else-if="loading">Carregando agendamento...</p>
    <p v-else-if="error" class="error">
      {{ error }} <button type="button" @click="load">Tentar novamente</button>
    </p>
    <dl v-else-if="schedule" class="details-grid">
      <div><dt>Título</dt><dd class="title-value">{{ schedule.title || '—' }}</dd></div>
      <div><dt>Descrição</dt><dd>{{ schedule.description || '—' }}</dd></div>
      <div><dt>Início</dt><dd>{{ dateLabel(schedule.start_date) }}</dd></div>
      <div><dt>Fim</dt><dd>{{ dateLabel(schedule.end_date) }}</dd></div>
      <div><dt>Tempo após on-air</dt><dd class="delay-value">{{ onAirDelay }}</dd></div>
    </dl>
  </div>
</template>

<script>
import axios from "axios";
import { config } from "../../config";

export default {
  name: "ConfirmationScheduleDetails",
  props: {
    scheduleId: { type: String, default: null },
    confirmedAt: { type: String, default: null },
  },
  data() {
    return { schedule: null, loading: false, error: null, requestId: 0 };
  },
  computed: {
    onAirDelay() {
      if (!this.schedule?.onair_at || !this.confirmedAt) return "Indisponível";
      const onAir = new Date(this.schedule.onair_at).getTime();
      const confirmation = new Date(this.confirmedAt).getTime();
      if (!Number.isFinite(onAir) || !Number.isFinite(confirmation) || confirmation < onAir) {
        return "Indisponível";
      }
      return `${((confirmation - onAir) / 60000).toFixed(2)} min`;
    },
  },
  watch: {
    scheduleId() { this.load(); },
  },
  mounted() { this.load(); },
  beforeUnmount() { this.requestId += 1; },
  methods: {
    dateLabel(value) {
      if (!value) return "Indisponível";
      const date = new Date(value);
      return Number.isNaN(date.getTime()) ? "Indisponível" : new Intl.DateTimeFormat("pt-BR", {
        dateStyle: "short", timeStyle: "medium", timeZone: "America/Sao_Paulo",
      }).format(date);
    },
    async load() {
      const id = ++this.requestId;
      this.schedule = null;
      this.error = null;
      if (!this.scheduleId) return;
      this.loading = true;
      try {
        const { data } = await axios.get(`${config.API}/v1/schedule/${encodeURIComponent(this.scheduleId)}`);
        if (id === this.requestId) this.schedule = data;
      } catch (error) {
        if (id === this.requestId) {
          this.error = error?.response?.status === 403 || error?.response?.status === 404
            ? "Agendamento indisponível ou sem acesso."
            : "Não foi possível carregar o agendamento.";
        }
      } finally {
        if (id === this.requestId) this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.confirmation-details { padding: 16px 0 16px 52px; border-bottom: 2px solid #3a6d8c; background: #f3f8fb; color: #2b4054; font: 13px "Globo-Regular", sans-serif; }
.confirmation-details p { margin: 0; }
.details-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(190px, 1fr)); gap: 16px 24px; margin: 0; }
.details-grid div { min-width: 0; text-align: center; }
dt { margin-bottom: 5px; color: #6f7b87; font-size: 12px; }
dd { margin: 0; overflow-wrap: anywhere; }
.title-value { font-family: "Globo-Bold", sans-serif; }
.delay-value { display: inline-block; padding: 4px 10px; border-radius: 6px; background: #e2f1f8; color: #2f5972; font-family: "Globo-Bold", sans-serif; }
.error { color: #b42318; }
.error button { border: 0; background: none; color: #3a6d8c; cursor: pointer; text-decoration: underline; }
</style>
